/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ViewDashboardIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="view-dashboard"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M7.5 21.5L2.5 21.5C2.5 18 2.498 14.5 2.5 11C2.5 10.733 2.553 10.467 2.657 10.222C2.876 9.705 3.313 9.294 3.843 9.11C4.054 9.037 4.276 9.001 4.5 9C4.833 8.999 5.167 8.999 5.5 9C5.68 9.001 5.858 9.024 6.032 9.071C6.659 9.244 7.176 9.728 7.39 10.343C7.463 10.554 7.5 10.777 7.5 11C7.502 14.5 7.5 18 7.5 21.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M15 21.5L9 21.5C9 16.5 8.998 11.5 9 6.5C9 6.277 9.037 6.054 9.11 5.843C9.309 5.271 9.771 4.809 10.343 4.61C10.554 4.537 10.777 4.5 11 4.5C11.667 4.499 12.333 4.499 13 4.5C13.484 4.501 13.957 4.678 14.321 4.998C14.449 5.111 14.563 5.24 14.658 5.382C14.755 5.525 14.833 5.68 14.89 5.843C14.963 6.054 15 6.277 15 6.5C15.002 11.5 15 16.5 15 21.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M21.5 21.5L16.5 21.5C16.5 19 16.498 16.5 16.5 14C16.5 13.646 16.594 13.296 16.773 12.991C17.012 12.582 17.396 12.266 17.843 12.11C18.054 12.037 18.276 12.001 18.5 12C18.833 11.999 19.167 11.999 19.5 12C19.635 12.001 19.77 12.014 19.903 12.041C20.542 12.171 21.089 12.621 21.343 13.222C21.429 13.425 21.481 13.643 21.495 13.863C21.498 13.909 21.5 13.954 21.5 14C21.502 16.5 21.5 19 21.5 21.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
    </svg>
  )
}
